import ReactDOM from 'react-dom';
import {ProjectRecommendations} from "./ProjectRecommendations.js";

export const main = () => {
	ReactDOM.render(
			<ProjectRecommendations
				proposalId={proposalId}
				schoolCity={schoolCity}
				schoolCounty={schoolCounty}
				schoolState={schoolState}
				showProjectRecommendations={showProjectRecommendations}
				onScrollElementId="load-project-recommendations-trigger"
			/>,
			document.getElementById("project-recommendations")
	);
}
